<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-1">Away With the Fairies</p>
<p class="book-subtitle" xml:lang="en-GB">A Phryne Fisher Mystery</p>
<p class="book-author" xml:lang="en-GB">Kerry Greenwood</p>
<p class="book-publisher" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="body-center"><span class="calibre1"><img alt="29375.png" class="frame" src="OEBPS/image/29375.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Away_With_the_Fairies.vue?5655258a